import { connect } from 'react-redux';

import { 
  _closeModifyTime,
  _saveModifyTime,
  _deleteModifyTime,
  _updateModifyTimeHour,
  _updateModifyTimeMinute
} from '@/actions/mainAction';

import ModifyTime from '@/components/main/ModifyTime';

export default connect(
  state => ({
    isOpen: state.main.isOpenModifyTimeModal,
    hour: state.main.modifyTimeInfo.hour,
    minute: state.main.modifyTimeInfo.minute,
    type: state.main.modifyTimeInfo.type,
    modified: state.main.modifyTimeInfo.modified,
  }),
  {
    _closeModifyTime,
    _saveModifyTime,
    _deleteModifyTime,
    _updateModifyTimeHour,
    _updateModifyTimeMinute
  }
)(ModifyTime);



// WEBPACK FOOTER //
// ./src/containers/main/ModifyTimeContainer.js